import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import {
  IMarketmakingTradeTableSearchParams,
  IMarketmakingTradeTableReport,
} from "../../../Interfaces/marketmaking";
import { getMarketmakingTradeTable } from "../../../Requests/marketmaking";

interface TradeTableProps {
  searchParam: IMarketmakingTradeTableSearchParams;
}

const MarketmakingTradeTable = ({ searchParam }: TradeTableProps) => {
  return (
    <div className="overflow-auto order-table w-full">
      <TableTemplate<
        IMarketmakingTradeTableSearchParams,
        IMarketmakingTradeTableReport
      >
        refreshTableTime={5000}
        getDataTable={getMarketmakingTradeTable}
        withSort
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            setSortingType={setSortingType}
            sortingType={sortingType}
            tableBoxClassName="max-h-[300px]"
          />
        )}
        searchParameters={searchParam}
      />
    </div>
  );
};

export default MarketmakingTradeTable;
